<div>
    <div class="modal-header">
        <h3>Edit Note</h3>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-2">
                <label>Text:</label>
            </div>
            <div class="col-md-10">
                <textarea style="width:100%; height: 100px;" [(ngModel)]="item.text"></textarea>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-default" (click)="cancel()">Cancel</button>
        <button class="btn btn-primary" (click)="submit(item)">Submit</button>
    </div>
</div>
